import { render, staticRenderFns } from "./registration_form.vue?vue&type=template&id=7fd6bd28&scoped=true&"
import script from "./registration_form.vue?vue&type=script&lang=js&"
export * from "./registration_form.vue?vue&type=script&lang=js&"
import style0 from "./registration_form.vue?vue&type=style&index=0&id=7fd6bd28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd6bd28",
  null
  
)

export default component.exports